/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-17 11:05:44
 * @FilePath: /unifyxp-v2-store-portal/src/router/SalesChannelEditorRoutes/index.ts
 */
/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import SalesChannelEditorLayout from '@/src/layout/SalesChannelEditorLayout/SalesChannelEditorLayout';

import { IRoutes } from 'src/types/router';

import routes from 'src/config/routerConfig/salesChannelEditor/salesChannelEditor';

const route: IRoutes = {
  layout: SalesChannelEditorLayout,
  subRoutes: routes,
};
export default route;
